const blocks = document.querySelectorAll(
  ".wp-block-portal-za-zenske-latest-blogs"
);

if (blocks.length) {
  import("./view-frontend.js").then(({ initBlock }) => {
    blocks.forEach((block) => initBlock(block));
  });
}
